import { render, staticRenderFns } from "./SignValueField.vue?vue&type=template&id=39c5995b&scoped=true"
import script from "./SignValueField.vue?vue&type=script&lang=ts"
export * from "./SignValueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c5995b",
  null
  
)

export default component.exports